import { React } from 'react';

const Loader = () => {
    return (
        <div className="flex-center">
            <div className="spinner-border"></div>
        </div>
    );
};

export default Loader;
